import { useEffect, useState } from 'react';

const EMPTY = {
  nombre: '',
  descripcion: '',
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState(EMPTY);

  const validateField = (field, value) => {
    let error = '';
    if (!value) {
      error = 'Este campo es obligatorio.';
    }
    setErrors(prev => ({ ...prev, [field]: error }));
  };

  const validateAll = () => {
    const newErrors = {};
    let isValid = true;
    Object.keys(EMPTY).forEach(key => {
      if (!form[key]) {
        newErrors[key] = 'Este campo es obligatorio.';
        isValid = false;
      }
    });
    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
    validateField(field, value);
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filledForm = {
        idNivel: data.idNivel ?? 0,
        nombre: data.nombre ?? '',
        descripcion: data.descripcion ?? '',
      };
      setForm(filledForm);
      Object.keys(filledForm).forEach(key => {
        if (key in EMPTY) validateField(key, filledForm[key]);
      });
    } else {
      setForm(EMPTY);
      setErrors(EMPTY);
    }
  }, [mode, data]);

  if (!open) return null;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo nivel' : 'Editar nivel'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>
      <div style={{ gridColumn: '1 / 3' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre: <span style={{ color: 'red' }}>*</span></label>
        <br /><br />
        <input
          className={`infoField${errors.nombre ? ' infoField--error' : ''}`}
          value={form.nombre}
          onChange={(e) => handleChange('nombre', e.target.value)}
          maxLength={150}
        />
        {errors.nombre && <small style={errorStyle}>{errors.nombre}</small>}
      </div>

      <div style={{ gridColumn: '1 / 3' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción: <span style={{ color: 'red' }}>*</span></label>
        <br /><br />
        <input
          className={`infoField${errors.descripcion ? ' infoField--error' : ''}`}
          value={form.descripcion}
          onChange={(e) => handleChange('descripcion', e.target.value)}
          maxLength={400}
        />
        {errors.descripcion && <small style={errorStyle}>{errors.descripcion}</small>}
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (validateAll()) {
            onSubmit(form, mode);
          }
        }}
        disabled={Object.values(form).some(x => !x) || Object.values(errors).some(x => x)}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
